var map = {
	"./game/1-1.jpg": "852a",
	"./game/1-2.jpg": "dd22",
	"./game/1-3.jpg": "7d30",
	"./game/1-4.jpg": "462c",
	"./game/2-1.jpg": "5c8c",
	"./game/2-2.jpg": "0a4c",
	"./game/2-3.jpg": "ed03",
	"./game/2-4.jpg": "8de8",
	"./game/3-1.jpg": "8b7e",
	"./game/3-2.jpg": "f0f9",
	"./game/3-3.jpg": "8f3c",
	"./game/3-4.jpg": "4d20",
	"./game/4-1.jpg": "9697",
	"./game/4-2.jpg": "df84",
	"./game/4-3.jpg": "fa1c",
	"./game/4-4.jpg": "648d",
	"./game/5-1.jpg": "f317",
	"./game/5-2.jpg": "ceba",
	"./game/5-3.jpg": "d293",
	"./game/5-4.jpg": "ee87",
	"./game/6-1.jpg": "c157",
	"./game/6-2.jpg": "a8c9",
	"./game/6-3.jpg": "b938",
	"./game/6-4.jpg": "36b4",
	"./hardware/1-1.jpg": "ba50",
	"./hardware/1-2.jpg": "edda",
	"./hardware/1-3.jpg": "9e8e",
	"./hardware/1-4.jpg": "c3e7",
	"./hardware/2-1.jpg": "17a0",
	"./hardware/2-2.jpg": "f598",
	"./hardware/2-3.jpg": "4d2b",
	"./hardware/2-4.jpg": "4e39",
	"./hardware/3-1.jpg": "65d8",
	"./hardware/3-2.jpg": "0758",
	"./hardware/3-3.jpg": "a6d5",
	"./hardware/3-4.jpg": "0490",
	"./hardware/4-1.jpg": "bc90",
	"./hardware/4-2.jpg": "666d",
	"./hardware/4-3.jpg": "2e4f",
	"./hardware/4-4.jpg": "e22f",
	"./hardware/5-1.jpg": "8bd7",
	"./hardware/5-2.jpg": "5dde",
	"./hardware/5-3.jpg": "9f8f",
	"./hardware/5-4.jpg": "8bbf",
	"./hardware/6-1.jpg": "df75",
	"./hardware/6-2.jpg": "0159",
	"./hardware/6-3.jpg": "1846",
	"./hardware/6-4.jpg": "ae7b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f228b";